<template>
  <div class="sw-modal confirm-dialog">
    <div v-click-outside="cancelAction" class="sw-modal-content">
      <div class="row sw-modal-heading">
        <div class="col">
          <h4>Please enter your PIN</h4>
        </div>
      </div>
      <div class="sw-modal-body">

        <ValidationObserver ref="responseForm">
            <form v-on:submit.prevent="submitPIN()">

              <div class="row">
                <div class="col-12">
                  To access the front desk, please enter your PIN.
                </div>
              </div>
              <div class="row question__question mt-4">
                <div class="col-12">
                  <ValidationProvider vid="oldPassword" rules="required|min:4|max:6" v-slot="{ errors }">
                    <input type="password" class="form-control short-question" v-model="pin" id="pin" ref="pinInput" maxlength="6" placeholder="Enter your PIN" required>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="row">
                  <div class="col-12">
                      <div v-if="error" class="infobar-error p-2">
                          {{error}}
                      </div>
                  </div>
              </div>
              <div class="sw-modal-actions">
                <div class="row">
                  <div class="col text-center">
                    <button class="btn btn-secondary" v-on:click.stop="cancelAction()">
                      Cancel
                    </button>
                    <button class="btn btn-primary">Continue</button>
                  </div>
                </div>
              </div>

            </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'PINDialog',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    establishmentReference: String,
    frontDeskURL: String,
    callbackName: String
  },
  data: function () {
    return {
      pin: '',
      error: null
    }
  },
  computed: {
  },
  methods: {
    cancelAction: function () {
      if (this.canCancel) {
        console.log('cancel')
        this.$root.$emit(this.callbackName)
      }
    },
    submitPIN: function () {
      console.log('continue')

      const body = {
        reference: this.establishmentReference,
        pin: this.pin
      }

      this.$http.post('/guest/v1/front-desk/' + this.frontDeskURL + '/validate-pin', body, { withCredentials: true }
      ).then(() => {
        this.$root.$emit(this.callbackName, true)
      }).catch(error => {
        if (error.response) {
          if (error.response.status === 401) {
            this.error = 'Incorrect PIN. Please try again.'
          } else if (error.response.status === 429) {
            if (error.response.headers && error.response.headers['retry-after']) {
              const retryAfter = error.response.headers['retry-after']
              this.error = `Too many attempts. Please try again after ${retryAfter} seconds.`
            } else {
              this.error = 'Too many attempts. Please try again later.'
            }
          } else {
            this.error = error.response.data.message
          }
        } else {
          this.error = "Sorry, we can't seem to reach our servers! Please try again"
        }

        setTimeout(() => {
          this.error = null
        }, 5000)
      })
    }
  },
  mounted () {
    this.$refs.pinInput.focus()
    setTimeout(() => {
      this.canCancel = true
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../styles/components/modal.scss";
  @import "../../styles/components/confirm_dialog.scss";
  @import "../../styles/components/_question_answer.scss";
</style>
